import Row from './Row';
import Dasher from '../sprites/Dasher';
import {
  GAME_END_HEIGHT,
  GAME_LANE_HEIGHT,
  GAME_ROAD_HEIGHT,
  GAME_ROAD_WIDTH,
  GAME_GRID_SIZE,
  GAME_GRID_START_X,
} from '../../constants/AppConstants';

export default class RowDashers extends Row {
  constructor({ game, rowNum, dasherCount = 2, minMoveSpeed, maxMoveSpeed, dasherVariations = 4, dasherType }) {
    super({ game, rowNum });
    this.rowNum = rowNum;
    this.dasherType = dasherType;
    this.dashers = [];
    this.dasherCount = dasherCount;
    this.dasherVariations = dasherVariations;
    this.MIN_MOVE_SPEED = minMoveSpeed;
    this.MAX_MOVE_SPEED = maxMoveSpeed;

    let dir = 1;

    if (rowNum !== 0) {
      //If it's odd
      if (((rowNum - 1) / 2) % 2 === 1) {
        //Flip the direction
        dir = -1;
      }
    }

    //Get a random movespeed inbetween constant values but offset by the row (so higher rows get faster)
    this.dir = dir;
    this.MOVE_SPEED = this.game.rnd.integerInRange(this.MIN_MOVE_SPEED + (rowNum + 1) * 10, this.MAX_MOVE_SPEED + (rowNum + 1) * 10);
    this.game.log(
      'MOVE SPEED',
      'Lane : ' + this.rowNum,
      'Move Speed : ' + this.MOVE_SPEED,
      'Direction : ' + this.dir,
      'Dasher count : ' + this.dasherCount
    );

    //Spawn the dashers within the row
    this.createDashers();
  }

  //Spawns the dashers at the start of the level
  createDashers() {
    let lastSpawnPos = 0;

    //Loop through the amount of dashers to be spawned
    for (let index = 0; index < this.dasherCount; index++) {
      //Spawn a new dasher
      let dasher = new Dasher({
        game: this.game,
        dir: this.dir,
        moveSpeed: this.MOVE_SPEED,
        variations: this.dasherVariations,
        rowInd: this.rowNum,
        id: index,
        dasherType: this.dasherType,
      });
      //Push it into the car aray
      this.dashers.push(dasher);

      //TODO - Create better random spawning algorithm as this only works for 2 dashers
      let randX = 0;

      if (index === 0) {
        randX = this.game.rnd.integerInRange(0, this.game.defaultWidth / 3);
      } else {
        randX = this.game.rnd.integerInRange((this.game.defaultWidth / 3) * 2, this.game.defaultWidth);
      }

      randX += this.game.rnd.integerInRange(200, 300);
      // //Position the dasher
      dasher.position.x = randX;
      dasher.position.y = 0; //this.rowPosY;
      this.addChild(dasher);
    }
  }

  //Updates the movement of each dasher in the row every frame
  step(timeStep) {
    this.dashers.forEach((element) => {
      element.move(timeStep, this.MOVE_SPEED);
    });
  }

  stopAnims() {
    this.dashers.forEach((element) => {
      element.stopAnimation();
    });
  }

  startAnims() {
    this.dashers.forEach((element) => {
      element.startAnimation();
    });
  }

  getColliders() {
    return this.dashers;
  }
}
